import { render, staticRenderFns } from "./config-list.vue?vue&type=template&id=560f1722&"
import script from "./config-list.vue?vue&type=script&lang=js&"
export * from "./config-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "config-list.vue"
export default component.exports